export default "__VITE_ASSET__Bc5B$Gr$__"